<template>
  <v-expansion-panel v-if="!flat" expand v-model="page.expand">
    <!-- <code>scopeSchema: {{scopeSchema}}</code>
    <code>defaultInputValues: {{defaultInputValues}}</code>
    <code>defaultForm: {{defaultForm}}</code>
    <code>form: {{form}}</code> -->
    <v-expansion-panel-content ripple>
      <slot name="header" slot="header">
        <div v-if="title">
          <h3>{{ title }}</h3>
        </div>
      </slot>
      <v-container fluid class="pa-1">
        <v-layout row wrap>
          <v-card v-for="{ key: propKey, value: propValue } in schemaProps" :key="propKey" :class="itemClasses(propValue)" style="box-shadow: none !important">
            <v-card-text
              :class="isRootSchema(propValue) ? 'px-2 py-0' : 'px-2 py-1'"
            >
              <MongoField
                ref="mongoField"
                v-if="isRootSchema(propValue)"
                v-model="form[propKey]"
                :label="propKey"
                :propSchema="propValue"
                
                :formRules="formRules.seek(propKey)"
                :defaultForm="getDefaultFormByKey(propKey)"
                :rowClasses="rowClasses"
                :expand="true"
                :flat="flat"
                :readonly="readonly"
              />
              <div v-else>
                <MongoFields
                  ref="mongoFields"
                  v-model="form[propKey]"
                  :defaultForm="getDefaultFormByKey(propKey)"
                  :title="titleText(propKey)"
                  :schema="propValue"
                  :mongooseSchema="mongooseSchema"
                  :formRules="formRules.seek(propKey)"
                  :rowClasses="rowClasses"
                  :expand="true"
                  :flat="flat"
                  :readonly="readonly"
                />
              </div>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-container>
    </v-expansion-panel-content>
  </v-expansion-panel>
  <div v-else>
    <!-- <v-flex v-for="{ key: propKey, value: propValue } in schemaProps" :key="propKey" :class="itemClasses(propValue)">
      <MongoField
        ref="mongoField"
        v-if="isRootSchema(propValue)"
        v-model="form[propKey]"
        :propSchema="propValue"
        :label="propKey"
        :rules="formRules[propKey]"
        :readonly="readonly"
      />
      <MongoFields
        v-else
        ref="mongoFields"
        v-model="form[propKey]"
        :defaultForm="getDefaultFormByKey(propKey)"
        :title="titleText(propKey)"
        :schema="propValue"
        :mongooseSchema="mongooseSchema"
        :rowClasses="rowClasses"
        :expand="true"
        :flat="flat"
        :readonly="readonly"
      />
    </v-flex> -->
  </div>
</template>

<script>
  import MongoField from './MongoField'
  import { titleText, objectToArray, deepmerge, getProp, debounce } from '../../libs/utils'
  import { getComponentBindingData, getDefaultModelValues, isRootSchema, createSchemaFromDocuments, HIDDEN_FIELDS_FOR_INSERT, MongoTableRules } from '../../libs/mongo-datatable'
  import { Schema } from 'mongoose/browser'

  export default {
    name: 'MongoFields',
    props: {
      value: { required: false, default: null },
      defaultForm: { required: false, default: () => ({}) },
      title: { required: false, default: '' },
      schema: { type: Object, required: true },
      mongooseSchema: { type: Schema, required: true },
      formRules: { type: MongoTableRules, required: false, default: () => new MongoTableRules() },
      rowClasses: { type: String, required: false },
      expand: { type: Boolean, required: false, default: false },
      flat: { type: Boolean, required: false, default: false },
      readonly: { type: Boolean, required: false, default: false }
    },
    data () {
      return {
        defaultInputValues: {},
        form: {},
        page: {
          expand: [this.expand]
        },
        schemaKeys: Object.keys(this.schema)
      }
    },
    mounted () {
      this.init(this.value)
    },
    computed: {
      schemaProps () {
        return objectToArray(this.schema).filter(
          item => !HIDDEN_FIELDS_FOR_INSERT.includes(item.key)
        )
        .map(schema => {
          if (getProp(schema, 'value.type') === Object && getProp(this.value || {}, schema.key) !== undefined) {
            console.log('dynamic schema', schema.value, this.value)
            schema.value = createSchemaFromDocuments([this.value[schema.key] || {}])
          }
          return schema
        })
        .sort((a, b) => {
          // tslint:disable-next-line
          let x1, x2, result

          /**
           * Sort by object is root schema
          */
          result = this.isRootSchema(b.value) - this.isRootSchema(a.value)
          if (result !== 0) return result

          /**
           * Sort by gsr_dashboard.order config in @yellow-capital/tp-database schema
          */
          x1 = getProp(a.value, ['gsr_dashboard', 'order'])
          x2 = getProp(b.value, ['gsr_dashboard', 'order'])
          if (x1 !== undefined || x2 !== undefined) {
            result = (x1 || 1000) - (x2 || 1000)
            if (result !== 0 && !isNaN(result)) return result
          }

          /**
           * Sort by Array schema type
          */
          x1 = Array.isArray(a.value.type)
          x2 = Array.isArray(b.value.type)
          result = x1 - x2
          if (result !== 0) return result

          /**
           * Sort by component name
          */
          x1 = getComponentBindingData(a.value).is
          x2 = getComponentBindingData(b.value).is
          result = x1 > x2 ? 1 : x1 < x2 ? -1 : 0
          if (result !== 0) return result

          /**
           * Sort by schema keys
          */
          x1 = this.schemaKeys.indexOf(a.key)
          x2 = this.schemaKeys.indexOf(b.key)
          result = x1 - x2
          return result
        })
      },
      scopeSchema () {
        return this.schemaProps
          .filter(prop => isRootSchema(prop.value))
          .reduce((c, prop) => {
            c[prop.key] = prop.value
            return c
          }, {})
      }
    },
    watch: {
      form: {
        deep: true,
        handler (val) {
          // FIXME: can't remove item in Array
          this.emitData(val)
        }
      },
      defaultForm: {
        deep: true,
        handler (val) {
          this.reset()
        }
      }
    },
    methods: {
      init () {
        this.defaultInputValues = getDefaultModelValues(this.scopeSchema)
        this.form = deepmerge(
          this.defaultInputValues,
          this.defaultForm
        )
      },
      reset () {
        // reset child components
        if (Array.isArray(this.$refs.mongoFields)) {
          this.$refs.mongoFields.forEach(component => {
            component.reset()
          })
        }
        if (Array.isArray(this.$refs.mongoField)) {
          this.$refs.mongoField.forEach(component => {
            component.reset()
          })
        }
        // this.$emit('input', val)
        this.$nextTick(() => this.init())
      },
      titleText,
      isRootSchema (schema) {
        return isRootSchema(schema)
      },
      itemClasses (propValue) {
        if (this.rowClasses) {
          return this.rowClasses
        }
        return this.isRootSchema(propValue) && !Array.isArray(getProp(propValue, ['type']))
          ? 'flex xs12 sm6 md4 lg3 xl2'
          : 'flex xs12'
      },
      getDefaultFormByKey (key) {
        return (this.defaultForm === null || this.defaultForm === undefined ? {} : this.defaultForm)[key]
      },
      emitData: debounce(function (val) {
        this.$nextTick(() => {
          this.$emit('input', val)
        })
      }, 10)
    },
    components: {
      MongoField
    }
  }
</script>

<style lang="scss" scoped></style>
